import { today, yesterday } from "components/DateTime/quickLinksModelUtc";
import { CAMPAIGN_ID_DIMENSION } from "model/report/dbTableCampaign";
import { DimensionIds, Events } from "model/reporterDb/dbTableCampaign";
import React from "react";
import { getRunningCampaignsObject } from "redux/campaignStatus/campaignStatusSelectors";
import { useSelector } from "redux/hooks";
import { fetchFlatReportParsed } from "services/reporter/fetch/fetchFlatReportParsed";
import { CampaignPageNotificationType, NotificationReason } from "../../types";
import generateNotifications from "./generateNotifications";
import { getReporterQuery } from "./getQuery";

export default function useCampaignReporterNotifications() {
  const campaignsObject = useSelector(getRunningCampaignsObject);
  const [campaignsListReport, setReport] = React.useState<any>([]);

  React.useEffect(() => {
    let isMounted = true;

    if (Object.keys(campaignsObject).length) {
      const metricsToQuery = ["rejectedInstall", Events.mmpInstall];

      const query = getReporterQuery({
        start: yesterday(),
        finish: today(),
        splits: [CAMPAIGN_ID_DIMENSION],
        filterBy: {
          [DimensionIds.CAMPAIGN_ID_COLUMN_ID]: {
            ...CAMPAIGN_ID_DIMENSION,
            value: Object.keys(campaignsObject),
          },
        },
        metrics: metricsToQuery.map((m) => ({ id: m, label: m })),
      });

      fetchFlatReportParsed({
        query,
        eventNames: ["id"].concat(metricsToQuery),
      }).then((parsedData) => {
        isMounted && setReport(parsedData);
      });
    }

    return () => {
      isMounted = false;
    };
  }, [campaignsObject]);

  const asyncCampaignNotifications: Array<CampaignPageNotificationType> =
    React.useMemo(
      () =>
        generateNotifications(
          {
            data: campaignsListReport,
            reason: NotificationReason.campaignRejectedInstallsHigh,
            condition: (s) =>
              s.mmpInstall / 10 <= s.rejectedInstall && s.rejectedInstall > 0,
          },
          campaignsObject
        ),
      [campaignsObject, campaignsListReport]
    );

  return asyncCampaignNotifications;
}
